<div [style.height]="size + 'px'" [style.width]="size + 'px'">
  <svg
    *ngIf="!_logoUrl && displayedText !== unknownName && !isCompany; else graphicalTemplate"
    [attr.height]="size"
    [attr.width]="size"
    [attr.viewBox]="'0 0 ' + size + ' ' + size"
  >
    <rect
      x="0"
      y="0"
      [attr.width]="size"
      [attr.height]="size"
      rx="50%"
      ry="50%"
      [attr.fill]="fillColor"
    />

    <text
      [attr.x]="size / 2"
      [attr.y]="size / 2 + size * 0.05"
      fill="white"
      alignment-baseline="middle"
      text-anchor="middle"
      [style.font-size]="size * 0.4 + 'px'"
    >
      {{ displayedText }}
    </text>
  </svg>

  <img
    *ngIf="super"
    [src]="superImageUrl"
    [attr.width]="size * 0.8"
    [attr.height]="size * 0.8"
    class="super"
  />
</div>

<ng-template #graphicalTemplate>
  <ng-container *ngIf="_logoUrl">
    <img
      style="height: 100%; width: 100%; object-fit: contain; border-radius: 50%"
      [src]="_logoUrl"
      alt=""
    />
  </ng-container>

  <ng-container *ngIf="!_logoUrl && displayedText === unknownName">
    <div class="special-version-avatar-icon">
      <mat-icon [ngStyle]="{ 'font-size': size * 0.6 + 'px' }">person</mat-icon>
    </div>
  </ng-container>

  <ng-container *ngIf="!_logoUrl && isCompany">
    <div class="special-version-avatar-icon" [ngStyle]="{ 'background-color': fillColor }">
      <mat-icon [ngStyle]="{ 'font-size': size * 0.6 + 'px' }">domain</mat-icon>
    </div>
  </ng-container>
</ng-template>
